module.exports = __webpack_public_path__ + "img/twitter.549a50fe.svg";